import React from 'react';
import { SimpleContentProps } from './types';
const SimpleContent: React.FC<SimpleContentProps> = ({ spec, type, index }) => {
    const { object } = spec;
    return <>{object}</>;
}

export default SimpleContent;